export default "/assets/images/la-strong-bg-sm.webp?777f0f85be890ae9ce37a6a349499cc1";